import * as yup from "yup";

const nullableString = yup.string().nullable();

export default {
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().required(),
    placeOfPurchase: nullableString,
    dateOfPurchase: nullableString,
    productNameAndModel: nullableString,
    serialNumber: nullableString,
    productAccessories: nullableString,
    installedBy: nullableString,
    installerName: nullableString,
    countryCode: nullableString,
};
